import { forwardRef } from 'react';

/**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */
export default forwardRef;